import { render, staticRenderFns } from "./TeamMemberCard.vue?vue&type=template&id=c239316a&scoped=true"
import script from "./TeamMemberCard.vue?vue&type=script&lang=js"
export * from "./TeamMemberCard.vue?vue&type=script&lang=js"
import style0 from "./TeamMemberCard.vue?vue&type=style&index=0&id=c239316a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c239316a",
  null
  
)

export default component.exports